import { useEffect } from 'react';
import Router from 'next/router';
import NProgress from 'nprogress';

import 'bootstrap/dist/css/bootstrap.css';
import '../scss/style.scss';
import '../public/fontawesome.min.css';
import '../public/typekit_zzt6tzx.css';
import '../public/swiper-bundle.css';
import 'nprogress/nprogress.css';

function MyApp({ Component, pageProps }) {
  NProgress.configure({ showSpinner: false });

  useEffect(() => {
    document.body.setAttribute('id', '_');
    document.body.setAttribute('itemScope', '');
    document.body.setAttribute('itemType', 'http://schema.org/WebPage');

    const handleRouteStart = () => NProgress.start();
    const handleRouteDone = () => NProgress.done();

    Router.events.on('routeChangeStart', handleRouteStart);
    Router.events.on('routeChangeComplete', handleRouteDone);
    Router.events.on('routeChangeError', handleRouteDone);

    return () => {
      // Remove on unmount
      Router.events.off('routeChangeStart', handleRouteStart);
      Router.events.off('routeChangeComplete', handleRouteDone);
      Router.events.off('routeChangeError', handleRouteDone);
    };
  }, []);

  return <Component {...pageProps} />;
}

export default MyApp;
